import React, { useEffect, useRef, useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { intlShape, injectIntl, FormattedMessage } from '../../../util/reactIntl';
import { Button } from '../../../components';
import { heroStylesData } from '../../../util/pageHeroHelper';
import './animatedCursor.css';

import mathImg from './math.png';
import englishImg from './english.png';
import scienceImg from './science.png';
import historyImg from './history.png';
import languagesImg from './languages.png';
import artsImg from './arts.png';

import css from './SectionHeroTeachers.module.css';


const imagesArray = [mathImg, englishImg, scienceImg, historyImg, languagesImg, artsImg];

const SectionHeroTeachers = props => {
  const [mounted, setMounted] = useState(false);
  const [index, setIndex] = useState(-1);
  const [isLastItem, setIsLastItem] = useState(false);
  const [heroStyles, setHeroStyles] = useState({});

  const {
    rootClassName,
    className,
    currentUser,
    handleGetStarted,
    currentState,
    currentSubject,
    content,
  } = props;

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if(currentSubject) {
      const currentStyles = heroStylesData.find(styles => styles.id === currentSubject.heroStyles);

      setHeroStyles(currentStyles)
    }


  }, [currentSubject]);

  const classes = classNames(rootClassName || css.root, className);

  const preStringTyped = () => {
    setTimeout(
      () => setIndex(index => index + 1),
      5000
    );

    if (index === imagesArray.length - 1) {
      setIndex(-1);
      setIsLastItem(true);
    }
  }

  const mainContainerClass = `coloredContainer_${index}`;

  const title = <FormattedMessage id='SectionFindJobHeroTeachers.title' />;
  const titleWithState = <FormattedMessage id='SectionFindJobHeroTeachers.titleWithState' values={{ state: currentState?.label }} />;
  const titleWithStateAndSubject = <FormattedMessage id='SectionFindJobHeroTeachers.titleWithStateAndSubject' values={{ state: currentState?.label, subject: currentSubject?.parent }} />;

  const gradientContainerClasses = (currentState && !currentSubject) ?
    classNames(css.gradientContainer, mainContainerClass, css.gradientContainerWithState) : (currentState && currentSubject )?
    classNames(css.gradientContainer, mainContainerClass, css.gradientContainerWithStateAndSubject) : classNames(css.gradientContainer, mainContainerClass);


  return (
    <div className={classes}>
      <div style={{backgroundColor: heroStyles.backgroundColor}} className={gradientContainerClasses}
           data-image={`image_${index}`}>
        <div className={css.heroContent}>
          <div className={(currentState && !currentSubject) ? classNames(css.heroContentText, css.heroContentTextBlack) : classNames(css.heroContentText) }>
            <h1
              className={currentSubject ? classNames(css.heroMainTitle, css.heroMainTitleSubject, { [css.heroMainTitleFEDelay]: mounted }) : classNames(css.heroMainTitle, { [css.heroMainTitleFEDelay]: mounted })}>
              {content?.heroTitle ?
                content.heroTitle :
                currentState && !currentSubject ?
                  titleWithState :
                currentState && currentSubject ?
                  titleWithStateAndSubject :
                title
              }
            </h1>
            <h2 className={classNames(css.heroSubTitle, { [css.heroSubTitleFEDelay]: mounted })}>
              {content?.heroDescription ?
                content.heroDescription :
                <FormattedMessage id='SectionHeroTeachers.heroSubTitle' />
              }
            </h2>

            {!currentUser && (
              <div className={css.emailContainer}>
                <Button style={{backgroundColor: heroStyles.buttonColor}} className={currentState ? classNames(css.heroButton, css.heroStateButton, { [css.heroButtonFEDelay]: mounted }) : classNames(css.heroButton, { [css.heroButtonFEDelay]: mounted })}
                        onClick={handleGetStarted}>
                  <FormattedMessage id='SectionHero.signUpJoinBtn' />
                </Button>
              </div>
            )}
          </div>

          <div className={css.heroContentImg}>
            <HeroImage src={heroStyles.imgSrc} imageIndex={index} />
          </div>
        </div>
      </div>
    </div>
  );
};

SectionHeroTeachers.defaultProps = { rootClassName: null, className: null };

SectionHeroTeachers.propTypes = {
  rootClassName: string,
  className: string,
  intl: intlShape.isRequired,
};

const HeroImage = (props) => {
  const { imageIndex, src = heroStylesData[0].imgSrc} = props;
  const i = imageIndex === -1 ? 0 : imageIndex;

  return <img src={src} alt='AllCourse' />;
};

export default injectIntl(SectionHeroTeachers);
